/* ts-cart-addons.js – Tomatosharp Organic V2 (erstattet ts-bold-cart.js)
   Bold Product Options (hybrid) legger de skjulte tilleggsproduktene (gravering,
   knivbeskytter) i kurven bare ved full sidelast med varer i kurven. Prestige sin
   kurvskuff oppdaterer uten sidelast, så kunder som går til kassen rett fra skuffen
   mistet tilleggene. Dette scriptet ber Bold synke etter hver kurvendring, tegner
   skuffen på nytt når kurven faktisk endret seg, og holder kurvtelleren fri for
   Bold sine skjulte linjer. */
(function () {
  'use strict';
  /* Kundetekster fra locales via snippets/ts-tekst.liquid (window.tsTekst), så /en/ kan oversettes. */
  var T = (window.tsTekst || {}).cart_addons || {};
  /* Kontraktsversjon mellom markup og script. Bumpes KUN når markup og JS endres på en måte som ikke er
     bakoverkompatibel – ikke ved vanlige CSS/JS-justeringer. Ellers ville hver push kastet åpne faner ut i reload. */
  var ASSET_VER = 'ts-cart-v3';
  window.__tsCartAddons = { loaded: true, version: '2026-09-17l', asset: ASSET_VER };

  /* Åpen fane med gammel JS: skuffen tegnes på nytt med ny markup, men scriptet er gammelt.
     Markup bærer sin JS-versjon i data-ts-js; ved avvik lastes siden på nytt (én gang per minutt) og skuffen åpnes igjen. */
  function checkFresh() {
    if (!ASSET_VER) return;
    var el = document.querySelector('[data-ts-js]');
    if (!el) return;
    var want = el.getAttribute('data-ts-js');
    if (!want || want === ASSET_VER) return;
    var last = 0;
    try { last = parseInt(sessionStorage.getItem('ts-js-reload') || '0', 10); } catch (e) {}
    if (Date.now() - last < 60000) return;
    try { sessionStorage.setItem('ts-js-reload', String(Date.now())); sessionStorage.setItem('ts-open-cart', '1'); } catch (e) {}
    window.location.reload();
  }
  document.addEventListener('cart-drawer:refreshed', function () { setTimeout(checkFresh, 50); });
  document.addEventListener('cart:change', function () { setTimeout(checkFresh, 80); });
  (function reopen() {
    var flag = null;
    try { flag = sessionStorage.getItem('ts-open-cart'); if (flag) sessionStorage.removeItem('ts-open-cart'); } catch (e) {}
    if (!flag) return;
    var n = 0;
    (function tryOpen() {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.show === 'function') { d.show(); return; }
      if (n++ < 40) setTimeout(tryOpen, 150);
    })();
  })();
  window.addEventListener('error', function (e) { if (e && e.filename && e.filename.indexOf('ts-cart-addons') > -1) console.error('ts-cart-addons feil:', e.message, e.lineno); });

  function isShadow(item) {
    var p = item && item.properties ? item.properties : {};
    return !!p._boldBuilderId && !p._boldVariantIds;
  }

  /* Runde 85 (20/10 2026): returfrakten for «Sliping per post» er en egen varelinje (variant fra data-retur-* på script-taggen,
     satt av ts-sliping-gruppe modus 'retur'). Regel: nøyaktig én linje (antall 1) når minst én «Sender selv» ligger i kurven og
     summen uten returfrakten er under grensen (øre); ellers ingen. Mangler attributtene, er regelen av. */
  var RETUR = (function () {
    var d = (document.currentScript && document.currentScript.dataset) || {};
    return { id: parseInt(d.returVariant, 10) || 0, fra: parseInt(d.returFra, 10) || 0, antall: parseInt(d.returAntall, 10) || 0,
      slip: d.returSlip || 'sliping-per-post', selv: String(d.returSelv || 'Sender selv').trim().toLowerCase() };
  })();
  function erRetur(i) { return !!RETUR.id && i.variant_id === RETUR.id; }
  /* 1/11 2026: på /en/ kan valgteksten være oversatt, så «Sender selv» kjennes også igjen på SKU-en (SLIP-POST-<antall>-SELV), som ikke oversettes. */
  function erSelv(i) { return /^SLIP-POST-.+-SELV$/i.test(i.sku || '') || (i.handle === RETUR.slip && String((i.variant_options || [])[1] || '').trim().toLowerCase() === RETUR.selv); }
  /* 1 hvis kurven (pluss ekstra øre / en «Sender selv» som er på vei inn) skal ha returfrakt, ellers 0. */
  /* Runde 106 (25/10 2026, eiervalg): fri returfrakt fra RETUR.antall kniver til sliping, uansett slipemetode og andre varer i kurven.
     Antall kniver per linje = første variantvalg («Antall kniver») × antall. ekstraKniver = kniver som er på vei inn fra produktsiden. */
  function returOnske(cart, ekstra, ekstraSelv, ekstraKniver) {
    var sum = (cart.total_price || 0) + (ekstra || 0), selv = !!ekstraSelv, kniver = ekstraKniver || 0;
    (cart.items || []).forEach(function (i) {
      if (erRetur(i)) { sum -= i.final_line_price; return; }
      if (i.handle === RETUR.slip) kniver += (parseInt((i.variant_options || [])[0], 10) || 0) * (i.quantity || 0);
      if (erSelv(i)) selv = true;
    });
    if (RETUR.antall > 0) return selv && kniver < RETUR.antall ? 1 : 0;
    return selv && sum < RETUR.fra ? 1 : 0;
  }
  window.__tsCartAddons.retur = { id: RETUR.id, onske: returOnske };

  function visibleCount(cart) {
    var n = 0;
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      /* Runde 85 (20/10 2026): returfraktlinja er ikke en vare i kurvtallet. */
      if (!isShadow(item) && !erRetur(item)) n += item.quantity;
    });
    return n;
  }
  /* 1/11 2026: ts-custom.js (retur fra kassen) må sammenligne med samme tall som kurvtelleren viser. */
  window.__tsCartAddons.visibleCount = visibleCount;
  window.__tsCartAddons.isShadow = isShadow;

  function fixCount(cart) {
    if (!cart || !cart.items) return;
    var n = visibleCount(cart);
    document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = n; });
  }

  function rootPath() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  /* fetch først; XMLHttpRequest som reserve hvis et app-script har ødelagt fetch. */
  function xhrJson(method, url, body) {
    return new Promise(function (resolve, reject) {
      try {
        var x = new XMLHttpRequest();
        x.open(method, url, true);
        x.setRequestHeader('Accept', 'application/json');
        if (body) x.setRequestHeader('Content-Type', 'application/json');
        x.onload = function () {
          if (x.status >= 200 && x.status < 300) { try { resolve(JSON.parse(x.responseText)); } catch (e) { reject(e); } }
          else reject(new Error('HTTP ' + x.status));
        };
        x.onerror = function () { reject(new Error('xhr error')); };
        x.send(body || null);
      } catch (e) { reject(e); }
    });
  }
  function cartJson(method, path, body) {
    var url = rootPath() + path;
    var opts = { method: method, credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } };
    if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = body; }
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).catch(function () { return xhrJson(method, url, body); });
  }
  function fetchCart() { return cartJson('GET', 'cart.js'); }

  /* Prestige-mønster: be seksjonene (kurvskuffen) melde seg, hent ferdig HTML i samme kall,
     og send cart:change. Unngår GET-henting av seksjonen, som Safari kan servere fra cache. */
  function bundledSections() {
    var list = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: list } }));
    return list;
  }
  var suppressSyncOnce = false;
  function rerender(cart) {
    if (cart && cart.sections && Object.keys(cart.sections).length) {
      suppressSyncOnce = true;
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: cart } }));
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }
  function rerenderFromServer() {
    var sections = bundledSections();
    return cartJson('POST', 'cart/update.js', JSON.stringify({ updates: {}, sections: sections.join(',') }))
      .then(function (cart) { rerender(cart); ensureEmptyDrawer(cart); return cart; })
      .catch(function () { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); });
  }

  function boldApp() {
    return window.BOLD && window.BOLD.options && window.BOLD.options.app;
  }

  var busy = false;
  var queued = null;
  var pending = 0;      /* tilleggsendringer som Bold ennå ikke har synket (9/10 2026: kassen venter på dem) */

  function onCartPage() {
    return !!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart');
  }

  function sync(known, done) {
    var app = boldApp();
    if (!app || typeof app.cartAdjusted !== 'function') { pending = 0; if (done) done(null, false); return; }
    if (busy) { queued = { known: known, done: done }; return; }
    busy = true;
    /* 1/11 2026: svarer Bold aldri, ble busy stående: kassen ventet 6 s hver gang og senere synker kjørte ikke. Slipp etter 8 s. */
    var utlopt = false;
    var vakt = setTimeout(function () {
      utlopt = true; busy = false; pending = 0;
      if (queued) { var next = queued; queued = null; sync(next.known, next.done); }
    }, 8000);
    try {
      app.cartAdjusted(function (fresh) {
        clearTimeout(vakt);
        if (!utlopt) busy = false;   /* sent svar: busy tilhører nå en nyere synk */
        if (pending > 0) pending--;
        fixCount(fresh);
        var changed = !known || fresh.item_count !== known.item_count || fresh.total_price !== known.total_price;
        if (changed && !done) {
          /* Runde 85 (20/10 2026): K5 svaret fra update.js er hele kurven; ryddingen bruker det i stedet for en ny GET /cart.js 50 ms etter. */
          rerenderFromServer().then(function (c) { if (c) removeOrphans(c); });
        } else if (!done) {
          removeOrphans(fresh);
        }
        if (done) done(fresh, changed);
        if (queued) { var next = queued; queued = null; sync(next.known, next.done); }
      });
    } catch (e) {
      clearTimeout(vakt);
      busy = false;
      if (pending > 0) pending--;
      if (done) done(null, false);
    }
  }

  /* Prestige-feil: når kurven blir tom oppdaterer ikke skuffen seg (animasjonen i replaceContent
     fullfører aldri). Etter cart:change med 0 varer: hvis skuffen fortsatt viser linjer, bytt innhold selv. */
  var lastDrawerRefresh = 0;
  document.addEventListener('cart-drawer:refreshed', function () { lastDrawerRefresh = Date.now(); });
  function ensureEmptyDrawer(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !cart || cart.item_count !== 0) return;
    /* Prestige flytter <cart-drawer> til <body>, så closest('.shopify-section') gir null. Bruk seksjons-id fra svaret
       eller fra seksjonswrapperen som fortsatt ligger i DOM. */
    var sectionId = '';
    if (cart.sections) { sectionId = Object.keys(cart.sections).filter(function (k) { return /cart-drawer/.test(k); })[0] || ''; }
    if (!sectionId) { var wrap = document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]'); sectionId = wrap ? wrap.id.replace('shopify-section-', '') : ''; }
    if (!sectionId) return;
    var started = Date.now();
    setTimeout(function () {
      if (lastDrawerRefresh >= started) return;                 /* temaet klarte det selv */
      if (!drawer.querySelector('line-item') && drawer.classList.contains('drawer--center-body')) return;
      var html = cart.sections && sectionId ? cart.sections[sectionId] : null;
      var apply = function (markup) {
        try {
          var doc = new DOMParser().parseFromString(markup, 'text/html');
          var src = doc.getElementById('shopify-section-' + sectionId);
          var inner = src ? src.querySelector('cart-drawer') : null;
          if (!inner) return;
          drawer.replaceChildren.apply(drawer, Array.prototype.slice.call(inner.children));
          drawer.classList.add('drawer--center-body');
          drawer.dispatchEvent(new CustomEvent('cart-drawer:refreshed', { bubbles: true }));
        } catch (e) { console.warn('ts-cart-addons: tom-kurv-reserve feilet', e.message); }
      };
      if (html) apply(html);
      else fetch(rootPath() + '?section_id=' + encodeURIComponent(sectionId), { cache: 'no-store' }).then(function (r) { return r.text(); }).then(apply).catch(function () {});
    }, 900);
  }

  /* Foreldreløse skjulte Bold-linjer (kniven fjernet, tillegget ligger igjen): fjern dem selv hvis Bold ikke gjør det. */
  /* Skjulte linjer som skal ned: foreldreløse til 0, og (D-02, avbrutt synk la beskytteren inn to ganger) ned til knivens antall. */
  /* raise (D-04b): også opp til knivens antall, brukes bare når vi selv endrer kniven.
     ponytail: _boldLineItemOneTime ignoreres her som før; et engangstillegg ville blitt ganget med antallet. */
  function shadowUpdates(items, raise) {
    var parents = {}, want = {}, updates = {}, n = 0;
    items.forEach(function (i) {
      var p = i.properties || {};
      if (!p._boldVariantIds || !p._boldBuilderId) return;
      parents[p._boldBuilderId] = true;
      splitList(p._boldVariantIds).forEach(function (v) { var k = p._boldBuilderId + ':' + v; want[k] = (want[k] || 0) + i.quantity; });
    });
    items.forEach(function (i) {
      if (!isShadow(i)) return;
      var b = i.properties._boldBuilderId, k = b + ':' + i.variant_id;
      if (!parents[b]) { updates[i.key] = 0; n++; }
      else if (want[k] !== undefined && (raise ? i.quantity !== want[k] : i.quantity > want[k])) { updates[i.key] = want[k]; n++; }
    });
    return n ? updates : null;
  }
  function removeOrphans(cart) {
    if (!cart || !cart.items) return Promise.resolve(false);
    var updates = shadowUpdates(cart.items);
    if (!updates) return Promise.resolve(false);
    return postUpdates(updates);
  }
  function postUpdates(updates) {
    var sections = onCartPage() ? [] : bundledSections();
    return cartJson('POST', 'cart/update.js', JSON.stringify({ updates: updates, sections: sections.join(',') })).then(function (fresh) {
      /* Lageret kan kappe kniven under tilleggene: rett tilleggene ned før vi tegner. */
      var fix = fresh && fresh.items ? shadowUpdates(fresh.items) : null;
      if (fix) return postUpdates(fix);
      if (onCartPage()) { window.location.reload(); return true; }
      /* Runde 85 (20/10 2026): svarer med kurven (sann verdi som før), så returSjekk kan gi den videre til Bold-synken. */
      rerender(fresh); ensureEmptyDrawer(fresh); return fresh;
    }).catch(function () { return false; });
  }

  /* Runde 85 (20/10 2026): håndhev returfraktregelen. Ett cart/update.js med variant-ID (linja har ingen egenskaper) og seksjoner;
     svaret tegnes med rerender, som ikke trigger ny Bold-synk. Kassevernet venter (returVenter).
     ponytail: maks to forsøk på rad uten at regelen blir oppfylt (f.eks. varen utsolgt/avpublisert), så det aldri går i løkke. */
  var returVenter = 0, returForsok = 0;
  function returSjekk(cart) {
    if (!RETUR.id || !cart || !cart.items) return Promise.resolve(null);
    var har = 0;
    cart.items.forEach(function (i) { if (erRetur(i)) har += i.quantity; });
    var vil = returOnske(cart, 0, false);
    if (har === vil) { returForsok = 0; return Promise.resolve(null); }
    if (returForsok++ >= 2) return Promise.resolve(null);
    var up = {}; up[RETUR.id] = vil;
    returVenter++;
    return postUpdates(up).then(function (fresh) { returVenter--; return fresh || null; });
  }

  /* 9/10 2026 (D-04): Prestige fjernet kniven med cart/change.js (~0,9 s), og først da kunne removeOrphans fjerne
     gravering og beskytter (~0,7 s til). Imens viste skuffen dem som egne rader med feil sum. Når en linje med tillegg
     endrer antall, tar vi over: kniven og de skjulte linjene i ett cart/update.js. (D-04b, 9/10: også økning, der
     /cart.js sto ~1,1 s med kniven × 2 og tilleggene × 1 før Bold løftet dem.) */
  function changeParent(lineKey, qty) {
    pending++;            /* kassevernet venter til kniven og tilleggene er ute */
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    return fetchCart().then(function (cart) {
      var items = cart.items.map(function (i) { return i.key === lineKey ? Object.assign({}, i, { quantity: qty }) : i; })
        .filter(function (i) { return i.quantity > 0; });
      var updates = shadowUpdates(items, true) || {};
      updates[lineKey] = qty;
      return postUpdates(updates);
    }).catch(function () {}).then(function () {
      if (pending > 0) pending--;
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    });
  }
  function takeOver(e, el, qty) {
    var li = el.closest('line-item');
    var input = li && li.querySelector('[data-ts-addon-remove]') ? li.querySelector('input[data-line-key]') : null;
    if (!input || isNaN(qty) || qty < 0 || qty === parseInt(input.defaultValue, 10)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    changeParent(input.getAttribute('data-line-key'), qty);
  }
  /* Runde 85 (20/10 2026): +/− i kurven sto stille i ~0,8 s (svaret fra /cart/change.js) før tallet endret seg.
     Nå byttes tallet med en gang og linja dempes (.ts-venter) til skuffen tegnes på nytt. Feil: temaet setter
     tallet tilbake selv, og dempingen tas bort 400 ms etter theme:loading:end. */
  function venter(el, qty) {
    var li = el.closest('line-item');
    if (!li || isNaN(qty)) return;
    var input = li.querySelector('input[data-line-key]');
    if (input && qty >= 1) input.value = qty;
    li.classList.add('ts-venter');
  }
  document.addEventListener('theme:loading:end', function () {
    setTimeout(function () {
      document.querySelectorAll('line-item.ts-venter').forEach(function (li) { li.classList.remove('ts-venter'); });
    }, 400);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('line-item [href*="/cart/change"]');
    if (!a) return;
    var qty = parseInt(new URL(a.href, location.href).searchParams.get('quantity'), 10);
    venter(a, qty);
    takeOver(e, a, qty);
  }, true);
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('line-item input[data-line-key]');
    if (!input) return;
    venter(input, parseInt(input.value, 10));
    takeOver(e, input, parseInt(input.value, 10));
  }, true);

  document.addEventListener('cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    var skip = suppressSyncOnce; suppressSyncOnce = false;
    ensureEmptyDrawer(cart);
    setTimeout(function () {
      fixCount(cart);
      /* Runde 85 (20/10 2026): returfrakten sjekkes også etter våre egne omtegninger (skip). Er regelen oppfylt, gjøres ingen kall. */
      if (skip) { returSjekk(cart); return; }
      /* Rydd foreldreløse tilleggslinjer selv først (raskere enn Bold), synk deretter hvis ingenting ble ryddet. */
      removeOrphans(cart).then(function (did) {
        if (did) return;
        /* Runde 85 (20/10 2026): returfrakten før Bold-synken; synken får den nye kurven, så den ikke tegner på nytt bare for returfrakten. */
        return returSjekk(cart).then(function (fresh) {
          if (boldApp() && typeof boldApp().cartAdjusted === 'function') sync(fresh || cart);
        });
      });
    }, 0);
  });

  document.addEventListener('cart:refresh', function () {
    /* Runde 85 (20/10 2026): returfraktregelen også her. */
    setTimeout(function () { fetchCart().then(function (c) { fixCount(c); returSjekk(c); }).catch(function () {}); }, 400);
  });

  /* --- Legg til / fjern tillegg direkte i kurven --------------------------- */
  var BOLD_KEYS = ['_boldVariantNames', '_boldVariantIds', '_boldProductIds', '_boldVariantPrices',
    '_boldVariantQtys', '_boldLineItemOneTime', '_boldProductOneTime', '_boldOrderOneTime', '_boldBuilderId'];

  function splitList(v) { return (v || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }

  function rebuildProps(item, action, addon, extra) {
    var p = Object.assign({}, item.properties || {});
    var names = splitList(p._boldVariantNames);
    var vids = splitList(p._boldVariantIds);
    var pids = splitList(p._boldProductIds);
    var prices = splitList(p._boldVariantPrices);
    var idx = names.indexOf(addon.name);

    if (action === 'remove' && idx > -1) {
      names.splice(idx, 1); vids.splice(idx, 1); pids.splice(idx, 1); prices.splice(idx, 1);
      delete p[addon.name]; delete p['_' + addon.name];   /* Runde 87 (21/10 2026): J8 begge navn, linjer fra før endringen har uten understrek */
      if (addon.name === 'Personlig inngravering') { delete p.Tekst; delete p.Skrifttype; }
    }
    if (action === 'add' && idx === -1) {
      names.push(addon.name); vids.push(addon.vid); pids.push(addon.pid); prices.push(addon.price);
      p['_' + addon.name] = '✓';           /* Runde 87 (21/10 2026): J8 skjult haken, som på produktsiden (formdata-lytteren under) */
      if (addon.name === 'Personlig inngravering' && extra) { p.Tekst = extra.text; p.Skrifttype = extra.font; }
    }

    if (names.length) {
      delete p._ts_addons;
      p._boldVariantNames = names.join(',');
      p._boldVariantIds = vids.join(',');
      p._boldProductIds = pids.join(',');
      p._boldVariantPrices = prices.join(',');
      p._boldVariantQtys = p._boldVariantQtys || '';
      p._boldLineItemOneTime = p._boldLineItemOneTime || '';
      p._boldProductOneTime = p._boldProductOneTime || '';
      p._boldOrderOneTime = p._boldOrderOneTime || '';
      /* Ny builder-id: gamle skjulte linjer blir «anonyme» og fjernes av Bold, nye legges til. */
      p._boldBuilderId = String(-Math.floor(Math.random() * 2000000000));
    } else {
      BOLD_KEYS.forEach(function (k) { delete p[k]; });
      /* Shopify ignorerer et tomt properties-objekt i /cart/change.js – da forblir gamle tillegg på linja.
         En skjult markør (understrek = vises ikke i kasse/ordre) tvinger gjennom utskiftingen. */
      if (Object.keys(p).length === 0) p._ts_addons = 'ingen';
    }
    return p;
  }

  /* Runde 87 (21/10 2026): J8 Bold skriver «Personlig inngravering: ✓» og «Legg til knivbeskytter: ✓» som synlige egenskaper på kniven
     (skjulte felt i produktskjemaet), og kassen viste tilleggene to ganger: haken på knivlinja og tilleggslinja. Når temaet bygger
     FormData av et /cart/add-skjema, får egenskaper med verdien ✓ understrek foran (skjult i kurv og kasse). Bold leser _bold*-feltene,
     ikke haken. «Tekst», «Skrifttype» og «Gave» har andre verdier og står som før. */
  document.addEventListener('formdata', function (e) {
    var f = e.target, fd = e.formData;
    if (!fd || !f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    Array.from(fd.keys()).forEach(function (k) {
      var m = /^properties\[([^_\]][^\]]*)\]$/.exec(k);
      if (!m || fd.get(k) !== '✓') return;
      fd.delete(k);
      fd.append('properties[_' + m[1] + ']', '✓');
    });
  }, true);

  function changeAddon(lineKey, action, addon, extra, pickerEl) {
    pending++;
    if (pickerEl) pickerEl.setAttribute('aria-busy', 'true');
    /* Runde 85 (20/10 2026): K5 samme ventetilstand som +/− (.ts-venter på linja) til skuffen er tegnet på nytt. */
    var li = pickerEl && pickerEl.closest ? pickerEl.closest('line-item') : null;
    if (li) li.classList.add('ts-venter');
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    var errEl = pickerEl && pickerEl.querySelector ? pickerEl.querySelector('[data-ts-addon-error]') : null;
    if (errEl) errEl.hidden = true;
    return fetchCart().then(function (cart) {
      var item = (cart.items || []).find(function (i) { return i.key === lineKey; });
      if (!item) throw new Error('line not found');
      var props = rebuildProps(item, action, addon, extra);
      var sections = onCartPage() ? [] : bundledSections();
      return cartJson('POST', 'cart/change.js', JSON.stringify({ id: lineKey, quantity: item.quantity, properties: props, sections: sections.join(',') }));
    }).then(function (cart) {
      /* Handlekurv-siden er ikke en seksjon som lytter på cart:refresh – last siden på nytt når Bold er ferdig. */
      if (onCartPage()) { document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true })); sync(cart, function () { window.location.reload(); }); return; }
      /* 9/10 2026: ny builder-id gjør de gamle skjulte linjene foreldreløse. Rydd dem før skuffen tegnes,
         ellers vises de som egne produktrader med feil sum i 1–3 s. removeOrphans tegner selv når den rydder. */
      return removeOrphans(cart).then(function (did) {
        if (!did) rerender(cart);
        /* Runde 85 (20/10 2026): K5 lastelinja (og .ts-venter) slutter først når skuffen er tegnet, ikke rett etter change.js. */
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        sync(cart);           /* Bold legger inn/fjerner skjulte linjer, så re-render igjen ved endring */
      });
    }).catch(function (e) {
      if (pending > 0) pending--;
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      if (li) li.classList.remove('ts-venter');
      if (pickerEl) pickerEl.removeAttribute('aria-busy');
      if (errEl) { errEl.textContent = T.kurv_feil; errEl.hidden = false; }
      console.warn('ts-cart-addons:', e.message);
    });
  }

  /* 9/10 2026: «Gå til kassen» mens Bold synker ga en kasse uten tillegget (sett: beskytter valgt, kassen 1,2 s etter,
     85 kr manglet). Hold igjen kasseskjemaet til synken er ferdig, maks 6 s. Gjelder skuff og /cart. */
  /* 13/10 2026: vent også mens en sliping-bestilling oppdateres (ts-sliping-gruppe.js setter aria-busy). Ellers kunne kassen
     åpnes midt i et variantbytte, med to hovedlinjer i kurven. */
  /* Runde 85 (20/10 2026): og mens returfraktlinja legges inn eller tas ut (returVenter). */
  /* Runde 86 (21/10 2026): og mens vedlikeholdssettet legges inn (settVenter). */
  function opptatt() { return busy || pending || returVenter || settVenter || !!document.querySelector('[data-ts-grp][aria-busy]'); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector || !f.querySelector('[name="checkout"]')) return;
    if (!opptatt()) return;
    e.preventDefault();
    var n = 0;
    (function vent() {
      if (!opptatt() || n++ > 40) {
        /* 9/10 2026 (I-1): skuffen kan ha blitt tegnet på nytt mens vi ventet, da er f frakoblet og submit() gjør ingenting. */
        if (!f.isConnected) {
          var btn = document.querySelector('cart-drawer [name="checkout"], form[action$="/cart"] [name="checkout"]');
          if (btn && btn.form) f = btn.form; else { window.location.href = rootPath() + 'checkout'; return; }
        }
        var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; f.appendChild(h);
        f.submit();
        return;
      }
      setTimeout(vent, 150);
    })();
  }, true);
  /* Runde 85 (20/10 2026): K6 «Kjøp med Vipps» i skuffen (ts-kurv-vipps.liquid) er en type="button" som Vipps-appen
     (hurtigkasse.js) lytter på selv, så submit-vernet over traff den ikke. Klikket holdes nå igjen på samme vilkår, maks 6 s,
     og sendes så videre. Lytteren ligger på window i fangstfasen, så den kommer før Vipps sin egen på knappen. */
  var slippVipps = false;
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.hurtigkasse-cart .hurtigkasse-btn');
    if (!btn || slippVipps || !opptatt()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.classList.add('ts-venter');
    var n = 0;
    (function vent() {
      if (opptatt() && n++ <= 40) { setTimeout(vent, 150); return; }
      btn.classList.remove('ts-venter');
      /* Skuffen kan ha blitt tegnet på nytt mens vi ventet; da er knappen byttet ut. */
      if (!btn.isConnected) btn = document.querySelector('cart-drawer .hurtigkasse-cart .hurtigkasse-btn') || document.querySelector('.hurtigkasse-cart .hurtigkasse-btn');
      if (!btn) return;
      slippVipps = true;
      try { btn.click(); } finally { slippVipps = false; }
    })();
  }, true);

  function addonFromEl(el) {
    return {
      name: el.getAttribute('data-addon-name'),
      pid: el.getAttribute('data-addon-pid'),
      vid: el.getAttribute('data-addon-vid'),
      price: el.getAttribute('data-addon-price')
    };
  }

  document.addEventListener('click', function (e) {
    /* Notat/rabattkode-toggle håndteres inline i markup (onclick), uavhengig av dette scriptet. */
    var add = e.target.closest('[data-ts-addon-add]');
    if (add) {
      e.preventDefault();
      var picker = add.closest('[data-ts-addon-picker]');
      changeAddon(picker.getAttribute('data-line-key'), 'add', addonFromEl(add), null, picker);
      return;
    }
    var rm = e.target.closest('[data-ts-addon-remove]');
    if (rm) {
      e.preventDefault();
      changeAddon(rm.getAttribute('data-line-key'), 'remove', { name: rm.getAttribute('data-addon-name') }, null, rm.closest('line-item'));
    }
  });

  /* Runde 86 (21/10 2026, eiervalg A): vedlikeholdssettet som egen varelinje, uten Bold.
     Kurven: «Legg til» ([data-ts-sett-add], ts-bold-addon-picker.liquid). Produktsiden: avkrysningen [data-ts-sett]
     (ts-vedlikehold-rad.liquid) huskes ved klikk på kjøpsknappen (skjemaet og den klebrige linja, også når K1 i ts-custom.js
     sender klikket videre til Bolds button.bold_clone). Settet legges inn først når temaet melder at kniven er lagt i kurven
     (cart:change «variant:add») og Bold-synken etter den er ferdig, så Bold-flyten er urørt. cart/update.js med variant-ID og
     antall 1 legger inn linja; ligger settet alt i kurven, gjøres ingenting (antallet økes aldri). Svaret tegner skuffen (postUpdates). */
  var settVenter = 0, settValgt = null;
  function leggTilSett(vid, el) {
    if (!vid) return Promise.resolve(null);
    settVenter++;
    if (el) el.setAttribute('aria-busy', 'true');
    return fetchCart().then(function (cart) {
      if ((cart.items || []).some(function (i) { return i.variant_id === vid; })) return null;
      var up = {}; up[vid] = 1;
      return postUpdates(up);
    }).catch(function () { return null; }).then(function (r) {
      settVenter--;
      if (el) el.removeAttribute('aria-busy');
      return r;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ts-sett-add]');
    if (!b) return;
    e.preventDefault();
    leggTilSett(parseInt(b.getAttribute('data-vid'), 10), b.closest('[data-ts-addon-picker]')).then(function () {
      /* Runde 103h (22/10 2026): «Passer til kniven» på PDP (ts-passer-til.liquid) bruker samme knapp. Der får kunden svar: knappen blir «Lagt til» og skuffen åpnes. */
      if (!b.classList.contains('ts-passer__btn')) return;
      b.textContent = T.lagt_til; b.disabled = true;
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.show === 'function') d.show();
    });
  });
  /* 29/10 2026: fargevelgeren på en «Passer til kniven»-linje (ts-passer-til.liquid, to produkter på én linje).
     Valget bytter variant-ID på knappen, lenkene og bildet; en knapp som alt sier «Lagt til» åpnes igjen for den nye fargen. */
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-ts-passer-velg]');
    if (!s) return;
    var o = s.options[s.selectedIndex], k = s.closest('[data-ts-addon-picker]'), b = k && k.querySelector('[data-ts-sett-add]');
    if (!o || !b) return;
    b.setAttribute('data-vid', o.value);
    b.setAttribute('aria-label', o.getAttribute('data-aria') || '');
    b.disabled = false; b.textContent = s.getAttribute('data-legg-til') || b.textContent;
    k.querySelectorAll('a[href]').forEach(function (a) { a.href = o.getAttribute('data-url'); });
    var img = k.querySelector('img');
    if (img && o.getAttribute('data-img')) { img.removeAttribute('srcset'); img.src = o.getAttribute('data-img'); }
  });
  window.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('button[type="submit"]');
    var f = k && k.form;
    var cb = f && /\/cart\/add/.test(f.getAttribute('action') || '') ? f.querySelector('[data-ts-sett]') : null;
    if (!cb) return;
    settValgt = cb.checked ? { vid: parseInt(cb.getAttribute('data-vid'), 10), t: Date.now() } : null;
  }, true);
  document.addEventListener('cart:error', function () { settValgt = null; });
  /* Runde 87 (21/10 2026): J4/J5 settet kom inn ~1,9 s etter at skuffen hadde åpnet (etter Bold-synken), så skuffen hoppet og summen endret seg.
     Nå holdes temaets cart:change («variant:add») tilbake (window, fangstfasen, før skuffen, kurvtelleren og K4 i ts-custom.js), settet legges inn
     med ett cart/update.js med seksjoner, og hendelsen sendes på nytt med den nye kurven. Skuffen åpner da én gang, ferdig, og kjøpsknappen står
     i «Legger i kurven …» til da (K4 slipper først på cart:change). Bold-synken kjører som før på cart:change, nå med settet i kurven.
     Ligger settet alt i kurven, eller kallet feiler, slippes den opprinnelige hendelsen videre. Rekkefølgen i skuffen: settet sist (cart-drawer.liquid). */
  window.addEventListener('cart:change', function (e) {
    var d = e.detail || {};
    /* ponytail: valget gjelder i 30 s etter klikket; Bold bruker ~2,3 s med tillegg. */
    if (!settValgt || d.baseEvent !== 'variant:add' || Date.now() - settValgt.t > 30000) return;
    var vid = settValgt.vid; settValgt = null;
    if (!vid || ((d.cart && d.cart.items) || []).some(function (i) { return i.variant_id === vid; })) return;
    e.stopImmediatePropagation();
    settVenter++;                        /* kassevernet venter til settet er inne */
    var up = {}; up[vid] = 1;
    cartJson('POST', 'cart/update.js', JSON.stringify({ updates: up, sections: bundledSections().join(',') })).catch(function () { return null; }).then(function (cart) {
      settVenter--;
      var nd = Object.assign({}, d);
      if (cart && cart.items && cart.sections) nd.cart = cart;
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: nd }));
    });
  }, true);

  function updatePreview(form) {
    var box = form.querySelector('[data-ts-engrave-preview]');
    if (!box) return;
    var text = (form.querySelector('[name="text"]').value || '').trim();
    var fontEl = form.querySelector('[name="font"]:checked') || form.querySelector('[name="font"]');
    var font = fontEl ? fontEl.value : 'Lato';
    box.textContent = text || 'Tomatosharp';
    box.style.fontFamily = "'" + font + "', " + (font === 'Dancing Script' || font === 'Lobster' || font === 'Rock Salt' ? 'cursive' : font === 'PT Serif' ? 'serif' : 'sans-serif');
    box.classList.toggle('is-rock-salt', font === 'Rock Salt');
  }
  document.addEventListener('input', function (e) {
    var form = e.target.closest('[data-ts-addon-form]');
    if (form) updatePreview(form);
  });
  /* Når graveringsvalget åpnes: rull skjemaet inn i synsfeltet i skuffen og sett fokus i tekstfeltet. */
  document.addEventListener('toggle', function (e) {
    var det = e.target;
    if (!det.matches || !det.matches('.ts-addon-picker__engrave') || !det.open) return;
    var form = det.querySelector('[data-ts-addon-form]');
    if (!form) return;
    updatePreview(form);
    setTimeout(function () {
      form.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      var t = form.querySelector('[name="text"]'); if (t) t.focus({ preventScroll: true });
    }, 50);
  }, true);
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-ts-addon-form]');
    if (form) updatePreview(form);
  });

  function submitEngraving(form) {
    var text = (form.querySelector('[name="text"]').value || '').trim();
    if (!text) { form.querySelector('[name="text"]').focus(); return; }
    var fontEl = form.querySelector('[name="font"]:checked') || form.querySelector('[name="font"]');
    var font = fontEl ? fontEl.value : 'Lato';
    var picker = form.closest('[data-ts-addon-picker]');
    changeAddon(picker.getAttribute('data-line-key'), 'add', addonFromEl(form), { text: text, font: font }, picker);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ts-addon-submit]');
    if (!btn) return;
    e.preventDefault();
    submitEngraving(btn.closest('[data-ts-addon-form]'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var form = e.target.closest('[data-ts-addon-form]');
    if (!form || e.target.getAttribute('name') !== 'text') return;
    e.preventDefault();
    submitEngraving(form);
  });
  /* Sikring: hvis et gammelt nestet form-element likevel finnes, ikke send handlekurv-skjemaet. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ts-addon-form]');
    if (form) { e.preventDefault(); submitEngraving(form); }
  });

  /* 1/11 2026: fraktlinja skrives bare av serveren (free-shipping-bar.liquid). Skuffen tegnes på nytt fra serveren ved hver endring og /cart
     lastes på nytt, så JS-omskrivingen som lå her ga bare et annet tall i 30 ms og kunne ikke gå tilbake fra «Fri frakt». */
  /* Rabattkode: temaet sender koden på «change» (blur). Enter i feltet gjorde ingenting,
     så Enter tar fokus ut av feltet og utløser samme «change». */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.keyCode !== 13) return;
    var input = e.target && e.target.closest ? e.target.closest('cart-discount-field input:not([type="hidden"])') : null;
    if (!input) return;
    e.preventDefault();
    input.blur();
  });
  /* Runde 53: Enter i antallsfeltet på /cart sendte kunden rett til kassen (skjemaets første submit-knapp).
     Nå tar Enter fokus ut av feltet, så antallet oppdateres via /cart/change.js og en eventuell lagermelding vises. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.keyCode !== 13) return;
    var qty = e.target && e.target.closest ? e.target.closest('form.cart-page input[data-line-key], line-item-quantity input') : null;
    if (!qty) return;
    e.preventDefault();
    qty.blur();
  });

  var tries = 0;
  (function boot() {
    var app = boldApp();
    if (app && app.cartHandler && app.shadowVariantsSyncing === false) {
      fetchCart().then(function (cart) {
        fixCount(cart);
        if (cart.item_count === 0) return;
        /* Runde 85 (20/10 2026): kurver fra før returfraktlinja (eller endret i en annen fane) rettes ved sidelast. */
        return returSjekk(cart).then(function (fresh) {
        if (fresh === true) return;            /* /cart lastes på nytt */
        cart = fresh || cart;
        if (onCartPage()) {
          /* Bold endret kurven ved lasting (f.eks. etter tilleggsendring): tegn siden på nytt én gang. */
          sync(cart, function (fresh, changed) {
            var key = 'ts-bold-reloaded';
            if (changed && !sessionStorage.getItem(key)) { sessionStorage.setItem(key, '1'); window.location.reload(); }
            else { sessionStorage.removeItem(key); }
          });
        } else {
          sync(cart);
        }
        });
      }).catch(function () {});
    } else if (tries++ < 60) {
      setTimeout(boot, 250);
    }
  })();
})();
